<template>
  <div class="dishes-slider--wrap" id="pdfable">
    <div class="close--overlay" 
      v-if="isOverlay"
      @click="() => transition(false)"
    >
      <img src="../assets/close-dishe-arrow.svg" />
      <span>chat</span>
    </div>
    <div id="swiper-bg">
      <div class="bg-wrap current-bg" 
        :style="{backgroundImage: `url(${currentBg})`}"
      ></div>
      <div class="bg-wrap new-bg" 
        :style="{backgroundImage: `url(${nextBg})`}"
      ></div>
      <div id="bg-results"></div>
    </div>
    <div class="swiper-container swiper-dishes-container">
      <div class="arrow-plate arrow-prev swiper-button-prev">
        <img src="../assets/arrow_plate_prev.svg" />
      </div>
      <div class="arrow-plate arrow-next swiper-button-next">
        <img src="../assets/arrow_plate_next.svg" />
      </div>
      <div class="swiper-wrapper">

        <div class="swiper-slide" v-for="(plates, i) in arrayPlates" :key="i">
          <img :src="plates.srcImage" />
          <div 
            class="add--plate" 
            @click="handleAddPlate"
          >
            <span class="indicator vertical"></span>
            <span class="indicator horizontal"></span>
          </div>
        </div>

      </div>
    </div>
    <div class="selection--wrap">
      <p class="plate-name">{{currentPlateName}}</p>
    </div>
    <ResultCtaVassoio 
      :resetSelection="resetSelection"
      :showTicket="showTicket" 
    />
    <Vassoio />
    <Ticket 
      :arrayTicket="arrayTicket" 
      :firstTrigger="starTicket"
    />
  </div>
</template>

<script>

import {mapState} from 'vuex';
import Swiper from 'swiper'
import 'swiper/css/swiper.css';
import {gsap, TimelineMax, Power2} from 'gsap';
import Vassoio from '@/components/Vassoio.vue'
import ResultCtaVassoio from '@/components/ResultCtaVassoio.vue'
import Ticket from '@/components/Ticket.vue'
import {arrayPlates} from '@/arrayPlates.js'
import {arrayPlatesIT} from '@/arrayPlatesIT.js'


export default {
  name: 'DishesSlider',
  props: ['closeOverlayDishes', 'isOverlay'],
  components:{
    Vassoio,
    ResultCtaVassoio,
    Ticket
  },
  data(){
    return {
      swiperEL: null,
      arrayPlates: [],
      arrayTicket: [],
      currentPlateName: '',
      currentSlide: 0,
      selectedPlates: [],
      currentBg: '',
      nextBg: '',
      starTicket: false
    }
  },
  methods:{
    initSwiper(){
      let that = this;
      this.swiperEL = new Swiper('.dishes-slider--wrap .swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints:{
          860:{
            slidesPerView: 3,
            spaceBetween: 50,
          }
        },
        centeredSlides: true,
        observer: true, 
        observeParents: true,
        grabCursor: true,
        // Navigation arrows
        navigation: {
          nextEl: '.dishes-slider--wrap .swiper-button-next',
          prevEl: '.dishes-slider--wrap .swiper-button-prev',
        },
        on: {
          slideChangeTransitionStart: function(){
            that.changeName(this)
          }
        }
      })
    },
    transition(val){
      
      if(val === false){
        gsap.to('.dishes-game-wrap', {duration: .75, left: '-100%', ease: Power2.easeInOut, 
          onComplete: () => {
            this.$store.dispatch('openOverlay', '')
            this.$store.dispatch('setMenuCtaVisibility',true);
            this.$store.dispatch('triggerReply')
          }
        })
      }
    },
    changeName(swiper){
      let newName = this.arrayPlates[swiper.activeIndex].name;
      let paragraph = document.querySelector('.plate-name');
      let currentBgWrap = document.querySelector('.current-bg');
      let newBgWrap = document.querySelector('.new-bg');

      let TL = new TimelineMax();

      let prevSlide = this.currentSlide
      this.currentSlide  = swiper.activeIndex;

      let dir = this.currentSlide - prevSlide;
      this.nextBg = this.arrayPlates[this.currentSlide].bgImage;

      gsap.set(newBgWrap, {x: dir > 0 ? '100%' : '-100%', opacity: 1,zIndex: 4})

      TL
      .to(paragraph, {opacity: 0, duration: .5, ease: Power2.easeOut,
        onStart: () =>{
          gsap.to(newBgWrap, {x: 0, duration: .4, ease: Power2.easeOut, 
            onComplete: () => {
              this.currentBg = this.arrayPlates[this.currentSlide].bgImage;
              setTimeout(() => {gsap.set(newBgWrap, {zIndex: 3})}, 400)
            }
          })
        },
        onComplete: () =>{
          paragraph.innerText = newName
        }
      })
      .to(paragraph, {opacity: 1, duration: .5, ease: Power2.easeOut})
      
    },
    handleAddPlate(){
      
      let plates = document.querySelectorAll('.plate-selected--wrap');
      let slides = document.querySelectorAll('.swiper-slide');
      event.currentTarget.classList.toggle('remove')
      
      if(event.currentTarget.classList.contains('remove')){
        this.selectedPlates.push(this.currentSlide)
      
        let img = new Image();
        img.classList.add('thumb');
        img.src = this.arrayPlates[this.currentSlide].srcImage

        plates[this.selectedPlates.length - 1].appendChild(img);

        slides[this.currentSlide].classList.add('selected');

        gsap.fromTo(img, 
        {scale: .2,  opacity: 0, rotation: -360},
        {scale: 1, opacity: 1,rotation: 0,duration: .5, ease: Power2.easeInOut,
          onComplete: () => {
            if(this.selectedPlates.length === 4){
              this.showResult()
            }
          }
        
        })
      }else{
        const index = this.selectedPlates.indexOf(this.currentSlide);
        if (index > -1) {
          this.selectedPlates.splice(index, 1);
        }

        let imgToRemove = plates[index].querySelector('.thumb');
        plates[index].removeChild(imgToRemove)
        slides[this.currentSlide].classList.remove('selected');
        
        for(var i = index; i < plates.length; i++){
          let nextImage = plates[i].querySelector('.thumb')
          if(nextImage){
            plates[i].removeChild(nextImage);
            plates[i - 1].appendChild(nextImage)
            
          }
        }
      }
    },
    showResult(){
      let TL = new TimelineMax()

      TL
      .to('.swiper-dishes-container', {autoAlpha: 0, duration: .75, ease: Power2.easeInOut})
      .to('.selection--wrap', {autoAlpha: 0, duration: .75, ease: Power2.easeInOut}, '-=.25')
      .fromTo('.vassoio--wrap',{y: window.innerWidth > 767 ? '40%' : '0'}, { y: '0%', duration: window.innerWidth > 860 ? .75 : 0, ease: Power2.easeInOut}, '-=.25')
      .to('.vassoio--bg', {width:'80%', maxWidth: 800, duration: .75, ease: Power2.easeInOut}, '-=.25')
      .to('.plates--selection', {height: window.innerWidth > 860 ? '100%' : '80%', duration: window.innerWidth > 860 ? .75 : 0, ease: Power2.easeInOut}, '-=1')
      .to('#bg-results', {y: 0, duration: .5, ease: Power2.easeInOut}, '-=.5')
      .to('.result-ctas--wrap', {autoAlpha: 1, duration: .75, ease: Power2.easeInOut}, '-=.5')
    },
    resetSelection(){

      this.selectedPlates = [];

      let slides = document.querySelectorAll('.swiper-slide');
      let thumbs = document.querySelectorAll('.thumb');

      

      for(var i = 0; i < slides.length; i++){
        slides[i].classList.remove('selected')
        var buttonAdd = slides[i].querySelector('.add--plate')
        buttonAdd.classList.remove('remove')
      }

      let TL = new TimelineMax()
      TL
      .to('.thumb', {opacity: 0, duration: .75, ease: Power2.easeInOut, 
        onComplete: () =>{
          for(var i = 0; i < thumbs.length; i++){
            thumbs[i].parentNode.removeChild(thumbs[i])
            this.swiperEL.slideTo(0, 0);
          }
        }
      })
      .to('.result-ctas--wrap', {autoAlpha: 0, duration: .75, ease: Power2.easeInOut, onComplete: () =>{
        gsap.set('#bg-results', {y: '-100%'})
      }})
      .to('.plates--selection', {height: window.innerWidth > 860 ? 'auto' : '80%', duration: window.innerWidth > 860 ? .75 : 0, ease: Power2.easeInOut}, '-=.25')
      .to('.vassoio--wrap', { y: window.innerWidth > 860 ? '40%' : '0', duration: window.innerWidth > 860 ? .75 : 0, ease: Power2.easeInOut}, '-=.25')
      .to('.vassoio--bg', {width:'60%', maxWidth: 650, duration: .75, ease: Power2.easeInOut}, '-=1')
      .to('.swiper-dishes-container', {autoAlpha: 1, duration: .75, ease: Power2.easeInOut}, '-=1')
      .to('.selection--wrap', {autoAlpha: 1, duration: .75, ease: Power2.easeInOut}, '-=.25')
      
    },
    showTicket(){
      let arraySelection = [];

      for(var i = 0; i < this.selectedPlates.length; i++){
        
        arraySelection.push(this.arrayPlates[this.selectedPlates[i]])
      }

      this.arrayTicket = arraySelection;

      let TL = new TimelineMax()
      
      TL
      .to('.vassoio--wrap', {duration: .5, autoAlpha: 0, x: '100%', ease:Power2.easeInOut})
      .to('.result-ctas--wrap', {duration: .5, autoAlpha: 0, x: '-100%', ease:Power2.easeInOut, onComplete:() =>{
        this.starTicket = true
      }}, '-=.5')
      
    }
  },
  mounted(){
    this.initSwiper()
    this.arrayPlates = this.$i18n.locale == 'it'? arrayPlatesIT : arrayPlates;
    this.currentPlateName = this.arrayPlates[0].name
    this.currentBg = this.arrayPlates[0].bgImage
    this.nextBg = this.arrayPlates[1].bgImage

  },
  beforeDestroy(){
    this.swiperEL = null
  },
  computed:{
    ...mapState({
      chatStep: state => state.chatStep,
      
    })
  },
  watch: {
  }
}
</script>

<style lang="scss">
  .dishes-slider--wrap{
    position: absolute;
    top: 0;
    left: 100%;
    height: 100%;
    width: 100%;
    background-color: rgb(86, 71, 141);
    overflow: hidden;
    z-index: 4;
    #swiper-bg{
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      .bg-wrap{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-position: 50%;
        background-size: cover;
        &.new-bg{
          transform: translateX(100%);
        }
        @media screen and(max-width: 860px){
          background-position: 0%;
        }
      }
      #bg-results{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-position: 50%;
        background-size: cover;
        background-image: url('../assets/section-bg-off.jpg');
        transform: translateY(-100%);
        z-index: 3;
      }
    }
    .swiper-container{
      position: relative;
      top: 0;
      height: 70%;
      width: 80%;
      margin: 0 auto;
      overflow: visible;
      z-index: 5;
      .swiper-wrapper{
        position: relative;
        margin: 0 auto;
        .swiper-slide{
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          transform: scale(.5);
          opacity: 1;
          transition: transform .5s ease-in-out, opacity .5s ease-in-out;
          img{
            width: 100%;
            max-width: 400px;
            margin: 0 auto;
          }
          &.swiper-slide-active{
            transform: scale(1);
            .add--plate{
              opacity: 1;
              transform: translateY(100%) scale(1) rotate(0deg);
            }
          }
          &.selected{
            img{
              opacity: .5;
            }
          }
          @media screen and(max-width: 860px){
            transform: scale(.85);
            &.swiper-slide-active{
              transform: scale(1);
            }
          }
        }
      }
      @media screen and(max-width: 860px){
        height: 50%;
        width: 60%;
      }
      @media screen and(max-width: 767px){
        height: 60%;
        width: 80%;
      }
    }
    .add--plate{
      position: absolute;
      background-color: #fff;
      border-radius: 50%;
      width: 80px;
      height: 80px;
      z-index: 4;
      border: 1px solid #000;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      right: 0;
      opacity: 0;
      transform: translateY(100%) scale(.1) rotate(-180deg);
      transition: opacity .5s ease-in-out, transform .5s ease-in-out;
      span{
        position: absolute;
        &.horizontal{
          height: 2px;
          width: 20px;
          opacity: 1;
          transform: rotate(0deg);
          background-color: #50AF72;
          transition: all .25s ease-in-out;
        }
        &.vertical{
          height: 2px;
          width: 20px;
          opacity: 1;
          transform: rotate(-90deg);
          background-color: #50AF72;
          transition: all .25s ease-in-out;
        }
      }
      &.remove{
        span{
          &.horizontal{
            height: 2px;
            width: 20px;
            opacity: 1;
            transform: rotate(180deg);
            background-color: #E25831;
            transition: all .25s ease-in-out;
          }
          &.vertical{
            height: 2px;
            width: 20px;
            opacity: 0;
            transform: rotate(0deg);
            background-color: #E25831;
            transition: all .25s ease-in-out;
          }
        }
      }
    }
    .selection--wrap{
      position: absolute;
      top: 60%;
      transform: translateY(100%);
      width: 100%;
      text-align: center;
      z-index: 5;
      .plate-name{
        color: #fff;
        font-size: 18px;
      }
      @media screen and(max-width: 860px){
        top: 50%;
        .plate-name{
          font-size: 24px;
        }
      }
      @media screen and(max-width: 767px){
        top: 55%;        
      }
    }
    
  }
  .arrow-plate{
    position: absolute;
    cursor: pointer;
    width: 40px;
    img{
      display: block;
      width: 100%;
    }
    &::after{
      content: '';
    }
    &.arrow-next{
      right: 0;
    }
    @media screen and(max-width: 860px){
      display: none;
    }
  }
  
</style>